export enum TRACKING_EVENTS {
  VALUE_INSERTION = 'valueInsertion',
  TABLE_UPDATE = 'tableUpdate',
  COLUMN_REORDER = 'columnReorder',
  COLUMN_ADDITION = 'columnAddition',
  COLUMN_SUBTRACTION = 'columnSubtraction',
  CHANNEL_ADDITION = 'channelAddition',
  PLATFORM_ADDITION = 'platformAddition',
  ROW_ADDITION = 'rowAddition',
  COLUMN_RESIZE = 'columnResize',
}
